/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2022-12-26 15:31:12
 * @LastEditors: linxi
 * @LastEditTime: 2022-12-27 17:19:22
 */
import {
  Button,
  Col,
  Form,
  Input,
  Modal,
  notification,
  Row,
  Space,
  Spin,
  Upload,
} from 'antd'
import React, { ReactElement, useContext, useEffect, useState } from 'react'
import {useDispatch, useSelector} from 'react-redux'
import { RootDispatch } from '../../app/store'
import { ThemeContext } from '../../theme/ThemeContext'
import { getClassificationRuleName, getSelfExecuteTypeName } from './column'
import { RectifyAndReformModal } from './RectifyAndReformModal'
import { UploadFile } from 'antd/lib/upload/interface'
import { getUrl } from '../treatment/oralCases/oralCasesSlice'
import { unwrapResult } from '@reduxjs/toolkit'
import {selectTenantCityCode} from "../../app/applicationSlice";
import axios from 'axios'
import { getSJWHTokenAsync } from '../dataMaintenance/organization/data'

interface detailModalProps {
  detail?: any
  selfExecuteType?: any
  visible: boolean
  onCancel: () => void
  onOk: () => void
  refreshList: () => void
}
export const DetailModal = ({
  detail,
  selfExecuteType,
  visible,
  onCancel,
  onOk,
  refreshList,
}: detailModalProps): ReactElement => {
  const [form] = Form.useForm()

  const theme = useContext(ThemeContext)

  const [loading, setLoading] = useState(false)

  const dispatch = useDispatch<RootDispatch>()

  const [detailMessage, setDetailMessage] = useState<any>()

  const [isModalVisible, setIsModalVisible] = useState<any>(false)

  const [lookPic, setLookPic] = useState("");
  const tenantCityCode = useSelector(selectTenantCityCode)

  const [isLookPicModalVisible, setIsLookPicModalVisible] = useState(false);

  const [lookPicName, setLookPicName] = useState("");

  // 查看按钮加载中的附件标识（downloadFile 返回 base64 渲染较慢，需要 loading）
  const [lookLoadingUid, setLookLoadingUid] = useState<string | number | null>(null);

  // 根据文件名后缀推断 MIME 类型（downloadFile 接口返回的是 base64）
  const getMimeByName = (name?: string) => {
    const ext = (name || "")
      .split(".")
      .pop()
      ?.toLowerCase();
    const map: Record<string, string> = {
      jpg: "image/jpeg",
      jpeg: "image/jpeg",
      png: "image/png",
      gif: "image/gif",
      bmp: "image/bmp",
      webp: "image/webp",
      tiff: "image/tiff",
      pdf: "application/pdf",
    };
    return map[ext || ""] || "image/jpeg";
  };

  // 查看附件：downloadFile 接口返回图片 base64，需转成 dataURL 才能显示
  const handleLookFile = async (item: any) => {
    if (lookLoadingUid !== null) return; // 防止重复点击
    setLookLoadingUid(item?.uid);
    try {
      const token: any = unwrapResult(await dispatch(getSJWHTokenAsync()));
      const MULTI_AXIOS_IP =
        window.location.origin +
        `/supervise_proxy/${tenantCityCode == "320200" ? "wuxi" : "jiangsu"}/admin-api`;
      // const MULTI_AXIOS_IP =
      //   "https://his.test.hydhis.com" +
      //   `/supervise_proxy/${tenantCityCode == "320200" ? "wuxi" : "jiangsu"}/admin-api`;
      const url =
        MULTI_AXIOS_IP +
        "/infra/file/downloadFile/" +
        item?.configId +
        "/" +
        item?.path;
      const res: any = await axios({
        url,
        headers: {
          "Content-Type": "application/json",
          "His-Auth": token,
        },
        withCredentials: false,
        method: "GET",
      });
      const base64 =
        typeof res?.data === "string" ? res.data : res?.data?.data;
      const mime = item?.fileType || getMimeByName(item?.name);
      setLookPic(`data:${mime};base64,${base64}`);
      setLookPicName(item?.name || "");
      setIsLookPicModalVisible(true);
    } catch (e) {
      notification.error({ message: "文件加载失败" });
    } finally {
      setLookLoadingUid(null);
    }
  };

  const labelStyle = {
    style: {
      color: theme.tc3,
      fontSize: '1rem',
      textAlign: 'right',
      marginBottom: 6,
      marginRight: '10px',
      width: '90px',
    } as React.CSSProperties,
  }

  const valueStyle = {
    flex: 1,
    style: {
      color: theme.tc1,
      fontSize: '1rem',
      marginBottom: 4,
    } as React.CSSProperties,
  }

  // useEffect(() => {
  //   if (visible) {
  //     setDetailMessage({
  //       ...detail,
  //       fileList: detail?.fileUrl ? detail?.fileUrl?.split(",")?.map((v: any) => {
  //         return {
  //           name: v?.split("@")[0],
  //           uid: v?.split("@")[1],
  //           url: v?.split("@")[2],
  //         };
  //       }) : [],
  //     })
  //   } else {
  //     setDetailMessage({})
  //   }
  // }, [visible])

  useEffect(() => {
    if (visible) {
      setDetailMessage({
        ...detail,
      })
    } else {
      setDetailMessage({})
    }
  }, [visible])

  return (
    <>
    <Modal
      title="查看详情"
      width={800}
      visible={visible}
      onCancel={() => {
        onCancel();
      }}
      centered
      footer={null}
      maskStyle={{
        overflow: "hidden",
      }}
      destroyOnClose
      maskClosable={false}
      bodyStyle={{ height: "420px" }}
    >
      <Form
        form={form}
        labelCol={{
          span: 4,
        }}
        wrapperCol={{
          span: 20,
        }}
      >
        <div style={{ height: "330px" }}>
          <Row gutter={20}>
            <Col span={24}>
              <Row>
                <Col {...labelStyle}>规则名称：</Col>
                <Col {...valueStyle}>{detailMessage?.ruleName}</Col>
              </Row>
            </Col>
            <Col span={12}>
              <Row>
                <Col {...labelStyle}>风险ID：</Col>
                <Col {...valueStyle}>{detailMessage?.id}</Col>
              </Row>
            </Col>
            {/*<Col span={12}>*/}
            {/*  <Row>*/}
            {/*    <Col {...labelStyle}>规则类型：</Col>*/}
            {/*    <Col {...valueStyle}>*/}
            {/*      {getClassificationRuleName(*/}
            {/*        detailMessage?.classificationRule?.toString()*/}
            {/*      )}*/}
            {/*    </Col>*/}
            {/*  </Row>*/}
            {/*</Col>*/}
            <Col span={12}>
              <Row>
                <Col {...labelStyle}>预警日期：</Col>
                <Col {...valueStyle}>{detailMessage?.riskDate}</Col>
              </Row>
            </Col>
            <Col span={12}>
              <Row>
                <Col {...labelStyle}>整改状态：</Col>
                <Col {...valueStyle}>
                  {getSelfExecuteTypeName(
                    detailMessage?.selfExecuteType?.toString()
                  )}
                </Col>
              </Row>
            </Col>
            {/*<Col span={24} style={{ margin: '10px 0 10px 0' }}>*/}
            {/*  <Row style={{ display: 'flex', fontSize: '1rem' }}>*/}
            {/*    <Col {...labelStyle}>预警指标：</Col>*/}
            {/*    <Col {...valueStyle} style={{ flex: '1' }}>*/}
            {/*      {detailMessage?.riskIndex}*/}
            {/*    </Col>*/}
            {/*  </Row>*/}
            {/*</Col>*/}
            <Col span={24} style={{ margin: " 0 0 6px 0" }}>
              <Row style={{ display: "flex", fontSize: "1rem" }}>
                <Col {...labelStyle}>风险描述：</Col>
                <Col {...valueStyle} style={{ flex: "1" }}>
                  {detailMessage?.preRiskSymptom}
                </Col>
              </Row>
            </Col>
            {selfExecuteType == "1" ? (
              <Col span={24}>
                <Row style={{ display: "flex", fontSize: "1rem" }}>
                  <Col {...labelStyle}>整改内容：</Col>
                  <Col {...valueStyle} style={{ flex: "1" }}>
                    {detailMessage?.selfExecuteContent}
                  </Col>
                </Row>
              </Col>
            ) : (
              ""
            )}
            <Col span={24} style={{ margin: " 0 0 6px 0" }}>
              <Row style={{ display: "flex", fontSize: "1rem" }}>
                <Col {...labelStyle}>上传资料：</Col>
                <Col {...valueStyle} style={{ flex: "1" }}>
                  {detailMessage?.fileList?.map((item: any) => (
                    <Row
                      gutter={24}
                      key={item.uid}
                      style={{
                        padding: "10px",
                        width: "400px",
                      }}
                    >
                      <Col flex={1}>
                        <span
                          style={{
                            display: "inline-block",
                            // maxWidth: "60px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            verticalAlign: "middle",
                          }}
                        >
                          {item.name.split(".")[0]}3
                        </span>
                        <span
                          style={{
                            verticalAlign: "middle",
                          }}
                        >
                          .{item.name.split(".")[1]}2
                        </span>
                      </Col>
                      <Col span={6}>
                        {lookLoadingUid === item.uid ? (
                          <Spin size="small" />
                        ) : (
                          <a onClick={() => handleLookFile(item)}>查看</a>
                        )}
                      </Col>
                    </Row>
                  ))}
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
        <div
          style={{ display: "flex", justifyContent: "center", width: "100%" }}
        >
          <Space>
            {selfExecuteType == "0" ? (
              <Button
                onClick={() => {
                  setIsModalVisible(true);
                }}
              >
                整改
              </Button>
            ) : (
              ""
            )}
            <Button
              type="primary"
              onClick={() => {
                onOk();
                setDetailMessage({});
              }}
            >
              确定
            </Button>
          </Space>
        </div>
      </Form>
      <RectifyAndReformModal
        ids={[detailMessage?.id]}
        visible={isModalVisible}
        onOk={() => {
          setIsModalVisible(false);
          refreshList && refreshList();
        }}
        onCancel={() => {
          setIsModalVisible(false);
          refreshList && refreshList();
        }}
      ></RectifyAndReformModal>
    </Modal>
    <Modal
      width={800}
      footer={null}
      title=""
      visible={isLookPicModalVisible}
      onOk={(v) => {
        setIsLookPicModalVisible(false);
      }}
      onCancel={(v) => {
        setIsLookPicModalVisible(false);
      }}
    >
      <div
        style={{
          maxHeight: "600px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          marginTop: "40px",
        }}
      >
        <img src={lookPic} style={{ width: "500px" }}></img>
        <a
          style={{ marginTop: "20px" }}
          href={lookPic}
          download={lookPicName || "download"}
        >
          下载
        </a>
      </div>
    </Modal>
    </>
  );
}
